// src/App.js
import React from 'react';
import AppRoutes from './routes/AppRoutes';

const App = () => {
    return (
        <div>
            <AppRoutes />
        </div>
    );
};

export default App;
